import { createContext } from "react";

export type AppContextType = {
    isSmallWindow: boolean;
};

export const AppContext = createContext<AppContextType>({
    isSmallWindow: false,
});
